import React, { Component } from 'react';
import { Container, Grid } from 'semantic-ui-react';
import appStore from '../images/app-store-badge.svg';
import googlePlay from '../images/google-play-badge.png';

class AppSection extends Component {
  render() {
    return (
      <Container
        fluid
        textAlign="center"
        id="app"
        style={{
          minHeight: '80vh',
          display: 'flex',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Grid stackable fluid style={{ marginTop: '-4em' }}>
          <Grid.Row centered style={{ marginBottom: '5em' }}>
            <h2> Essayez l'application gratuitement </h2>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={8} centered stretched>
              <a href="https://itunes.apple.com/fr/app/paraphe-online/id1260472844?mt=8">
                <img src={appStore} alt="AppStore logo" width="300px" />
              </a>
            </Grid.Column>
            <Grid.Column width={8} centered stretched>
              <a href="https://play.google.com/store/apps/details?id=com.parapheonline">
                <img src={googlePlay} alt="Google Play logo" width="300px" />
              </a>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default AppSection;



// WEBPACK FOOTER //
// ./src/components/AppSection.js